import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CompanyReport, ReportFilter } from "../models/report.models";

export const ReportsActions = createActionGroup({
    source: "Reports",
    events: {
        "Page Opened": props<{ clientId: string }>(),
        "Page Requested": props<{ token: string; pageIndex: number }>(),
        "Page Loaded": props<{
            reports: CompanyReport[];
            nextToken: string | null;
            token: string;
            pageIndex: number;
        }>(),
        "Page Load Failed": emptyProps(),
        "Query Changed": props<{ query: string }>(),
        "Filter Changed": props<{ filter: ReportFilter }>(),
        "Download Requested": props<{ report: CompanyReport }>(),
        "Download Succeeded": emptyProps(),
        "Download Failed": emptyProps(),
        "Download Status Cleared": emptyProps(),
    },
});
